import { memo } from 'react'

import {
  Wrapper,
  Info,
  MetaInfo,
  IconBlock,
  Title,
  Description,
  Btns
} from './styles'


interface props {
  icon?: JSX.Element | null;
  title?: string;
  description?: string;
  actionFirst?: JSX.Element | null;
  actionSecond?: JSX.Element | null;
}

function ActionLine({ icon, title, description, actionFirst, actionSecond }: props) {

  return (
    <Wrapper>

      <Info>
        <IconBlock>
          {icon}
        </IconBlock>
        <MetaInfo>
          <Title>{title}</Title>
          <Description>{description}</Description>
        </MetaInfo>
      </Info>
      <Btns>
        {actionFirst}
        {actionSecond}
      </Btns>

    </Wrapper>
  )

}


export default memo(ActionLine)